import React, {useState} from 'react';
import {DayPicker} from 'react-day-picker';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../models/device.view-model";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {IOC} from "../../../infrastructure/ioc";
import {DatePickerComposer} from "./date-picker.composer";
import classNames from "classnames";
import {ALL_SCORES} from "../../../widgets/all-scores-widget/all-scores-widget-consts";
import {ROUTE_NAMES} from "../../consts";
import {DASHBOARD} from "../../../containers/dashboard-container/dashboard-container.consts";
import "./date-picker.scss";

export class DatePickerProps extends BaseProps {
  onChange: Function;
  goto: Function;
  selectedDate: Date;
  device: DeviceViewModel;
  linkType: BaseLinkModel;
  ioc: IOC;
  locale: Object;
}

export const DatePicker = DatePickerComposer(({controller, locale, selectedDate, goto}: DatePickerProps) => {
  const {state, terms, config} = controller;
  const {sportTypeId, currentLinkModel} = state;
  const {WEB_MY_SCORES_TODAY_BUTTON} = terms
  const {source} = config
  const getPageDate = () => {
    let pageDate = new Date();

    const filter = currentLinkModel?.params.filter
    if(currentLinkModel?.name === ROUTE_NAMES.allScores && filter !== DASHBOARD.FILTERS.live && filter !== undefined) {
      pageDate = new Date(filter)
    }

    return pageDate
  }

  const [pageDate, setDate] = useState(getPageDate())

  const containerProps = {
    className: classNames('date-picker-tooltip'),
    onClick: (e) => e.stopPropagation()
  }

  const pickerProps = {
    locale: locale,
    onDayClick: (date: Date) => {
      controller.action(ALL_SCORES.ANALYTICS.ACTION_TYPES.onCalendarDateCellClick, {
        source,
        sportTypeId,
        cellDate: controller.state?.datetimeUtils.toServerDate(date),
        datesInterval: controller.state?.datetimeUtils.diffDaysByDate(date)
      });
      goto(date)
    },
    mode: 'single',
    required: true,
    selected: selectedDate,
    defaultMonth: selectedDate,
    onMonthChange: (date) => {
      setDate(date)

      controller.action(ALL_SCORES.ANALYTICS.ACTION_TYPES.onCalendarArrowClick, {
        source,
        sportTypeId,
        arrowType: ALL_SCORES.ANALYTICS.ARROW_CLICK_TYPES.month,
        direction: getMonthDirection(date)
      })
    }
  }

  const getMonthDirection = (date: Date) => {
    let direction = null;

    if (date > pageDate) {
      direction = ALL_SCORES.ANALYTICS.ARROW_CLICK_DIRECTION.forward;
    } else if(date < pageDate) {
      direction = ALL_SCORES.ANALYTICS.ARROW_CLICK_DIRECTION.backward;
    }

    return direction
  }

  const toadyProps = {
    className: classNames('today-button'),
    onClick: () => {
      controller.action(ALL_SCORES.ANALYTICS.ACTION_TYPES.onCalendarTodayClick, {source, sportTypeId})
      goto(new Date());
    }
  }

  return (
    <div {...containerProps}>
      <DayPicker {...pickerProps} />
      <div {...toadyProps}>{WEB_MY_SCORES_TODAY_BUTTON}</div>
    </div>
  );
});
